import React, { useEffect, useRef, useState } from 'react'
import axios from 'axios'
import toast from 'react-hot-toast'
import { Url } from '../services/Constants'
import {Setauth} from "../services/Auth" 
import { refereshState,delAllCart } from "../redux/action";
import { useDispatch,useSelector } from "react-redux";
import { HighlightOff, ShoppingCart, BusinessCenter, ArrowBack } from '@mui/icons-material'
import { SetUserRole } from '../services/UserRole'
import { CartUpdate } from '../services/CartUpdate'
import { setHeader } from '../services/Headers'
import { Oval } from 'react-loader-spinner';
import { useLocation,useNavigate } from 'react-router-dom'


export default function Login({data}) {

    const state = useSelector((state) => state.handleCart)

    const mobile_number = useRef()
    const finalotp = useRef()

    const location = useLocation();
    const fullUrl = location.pathname
    const Navigate = useNavigate()
    const [otp, setOtp] = useState(false)
    const [isloader, setIsloader] = useState(false);
    const [usertype,setUserType] = useState(false) // true:a seller, false:a buyer  By default a buyer
    const [mobile, setMobile] = useState()
    const [mobileNumber, setMobileNumber] = useState()
    const [numberErr,setNumberErr] = useState(false)
    const [formdata, setFormdata] = useState()
    const dispatch = useDispatch(); 
    
    
    
    useEffect(()=>{},[data.login,isloader])

    const loginToggle=()=>{
        data.loginHandle()
    }

    const userTypeToggle = ()=> setUserType(!usertype)

    const registerToggle =()=>{
        data.loginHandle()
        data.registerHandle()
    }

    const numberCheck = ()=>{
        const value = mobile_number.current.value
        const isNumber = (value) => {
            return isNaN(value) && value.trim() !==' ';
          }
        if(isNumber(value)){
                setNumberErr(true)
        }else
        {
            setNumberErr(false)
        }
    }

    const numberLengthCheck = ()=>{
      const value = mobile_number.current.value
      const valueLength = value.length
      const numberLength = value.trim().length
      if(numberLength<10 && numberLength>0 || valueLength===1){
        setNumberErr(true)
      }else
      {
          setNumberErr(false)
      }
    }

    const getOtp = async (e) => {
        e.preventDefault()
        let user = {mobile_number:mobile_number.current.value,
                      mobile_code:91,
                     }
            setMobile(mobile_number.current.value)

        if(!usertype){
                user={...user,role:"buyer"}
                try {
                    const result = await axios.post(`${Url}/sessions/login`,user)
                    // console.log(result)
                    if(result.data.response_code === 401){
                      toast.error("User not found!")
                    }else if(result.data.response_code === 200){
                      setOtp(!otp)
                      setFormdata(user)
                      toast.success("OTP send successfully.")
                    }else{
                      toast.error("Something went wrong!")
                    }
                } catch (error) {
                    console.log(error)
                }
        }
        else{
            user={...user,role:"seller"}
                try {
                    const result = await axios.post(`${Url}/sessions/login`,user)
                    // console.log(result)
                    if(result.data.response_code === 401){
                      toast.error("User not found!")
                    }else if(result.data.response_code === 200){
                      setOtp(!otp)
                      setFormdata(user)
                      toast.success("OTP send successfully.")
                    }else{
                      toast.error("Something went wrong!")
                    }
                } catch (error) {
                    console.log(error)
                }
                
        }
    }

    const loginHandle = async (e)=>{
        e.preventDefault()
        setIsloader(true)
            let user = formdata
            user = {...user,otp:finalotp.current.value}
          // console.log(user)
          try {
            const result = await axios.post(`${Url}/sessions/verify_otp`, user)
            if(result.data.response_code !== 400){
              const token = result.data.response_data.token
              Setauth(token)
              SetUserRole(user.role)
              data.loggedinHandle()
              toast.success("Logged In Successfully")
              if(user.role==="seller"){
                data.homeRole()
              }
               const a= await CartUpdate()
                 if(fullUrl === "/cart"){
                   setIsloader(false)
                   Navigate("/")
                  }
                  // dispatch(delAllCart())
                  setIsloader(false)
                    Navigate("/")
                  dispatch(refereshState());
                  loginToggle()


            }else{
              toast.error("Invalid OTP!")
              setIsloader(false)
            }
          } catch (error) {
            console.log(error)
          setIsloader(false)
          toast.error("Something went Wrong, please try again!")
          }
      }
    
      const resendHandle = async (e) => {
        e.preventDefault()
        let user = {mobile_number:mobile,
          mobile_code:91,
        }

        if(!usertype){
                user={...user,role:"buyer"}
                try {
                    const result = await axios.post(`${Url}/sessions/resend_otp`,user)
                    // console.log(result)
                    if(result.data.response_code === 401){
                      toast.error("User not found!")
                    }else if(result.data.response_code === 200){
                      toast.success("OTP resend successfully.")
                    }else{
                      toast.error("Something went wrong!")
                    }
                } catch (error) {
                    console.log(error)
                    toast.error("Something went Wrong, please try again!")          
                }
        }
        else{
            user={...user,role:"seller"}
                try {
                    const result = await axios.post(`${Url}/sessions/resend_otp`,user)
                    // console.log(result)
                    if(result.data.response_code === 401){
                      toast.error("User not found!")
                    }else if(result.data.response_code === 200){
                      toast.success("OTP resend successfully.")
                    }else{
                      toast.error("Something went wrong!")
                    }
                } catch (error) {
                    console.log(error)
                    toast.error("Something went Wrong, please try again!")
                }
        }
    }
    


  return (
    <>
   {data.login?<div className=" login-container w-full h-screen bg-opacity-75 bg-black flex justify-center items-center fixed top-0 z-50 ">
        <div className="login-modal w-96 bg-gray-300 rounded-2xl shadow-2xl z-40 max-sm:w-[90%]">
          <div className="login-modal-top w-full mx-auto flex flex-col items-center">
            <div className={otp?"close w-full text-end p-[1.2%] flex justify-between":" close w-full text-end p-[1.2%]"}>
            {otp?<ArrowBack
            sx={{ fontSize: 28 }}
            className="cursor-pointer rounded-full ml-1 mt-1" 
            onClick={()=>setOtp(!otp)}/>:""}
            <HighlightOff
              sx={{ fontSize: 28 }}
              className="hover:bg-red-700 hover:text-white cursor-pointer rounded-full m-0 p-0"
              onClick={loginToggle}
            /></div>
            <img
              src="../assets/Logo.png"
              alt="Tsofie-logo"
              className="w-2/5 my-4"
            />
          </div>
          <div className="login-modal-bottom flex flex-col justify-center items-center">
          <div className="register-type mt-[2%] mb-[4%] text-white rounded-t-lg bg-amber-950 flex w-3/4 justify-center items-center">
            {!usertype?<><div className="register-buyer py-2 text-center rounded-t-lg text-black font-bold bg-gradient-to-b from-amber-950 via-amber-800 to-gray-300 w-1/2 cursor-default ">
                <ShoppingCart/>
                <span className="buyer-form">Buy</span>
            </div>
            <div className="register-seller py-2 text-center w-1/2 cursor-pointer hover:text-gray-400" onClick={!otp?userTypeToggle:(e)=>e.preventDefault()}>
                <BusinessCenter/>
                <span className="seller-form">Sell</span>
            </div></>
            :<><div className="register-buyer py-2 text-center w-1/2 cursor-pointer hover:text-gray-400" onClick={!otp?userTypeToggle:(e)=>e.preventDefault()}>
                <ShoppingCart/>
                <span className="buyer-form">Buy</span>
            </div>
            <div className="register-seller py-2 text-center rounded-t-lg text-black font-bold bg-gradient-to-b from-amber-950 via-amber-800 to-gray-300 w-1/2 cursor-default">
                <BusinessCenter/>
                <span className="seller-form">Sell</span>
            </div></>}
        </div>
            {!otp?<>
            {numberErr?<span className="numbererr text-red-700 w-3/4 pl-3 text-left text-xs">Please Enter A Valide Mobile Number!</span>:""}
            <input
              type="text"
              className={!numberErr?"form-control w-3/4 box-border mb-[3%] p-3 outline-none shadow-xl rounded-3xl":"form-control w-3/4 box-border mb-[3%] p-3 outline-none border-2 border-red-700 shadow-xl rounded-3xl"}
              placeholder="Your Mobile Number"
              ref={mobile_number}
              onKeyUp={numberCheck}
              onBlur={numberLengthCheck}
              maxLength={10}
            /></>:""}
            {/* <input
              type="password"
              className="w-3/4 h-10 box-border mb-5 p-3 outline-none  shadow-xl rounded-3xl"
              placeholder="Password"
            /> */}
            {otp?<>
            <span className="freezenumber w-3/4 h-10 border bg-white opacity-50 text-amber-950 mb-3 p-2 font-bold shadow-xl rounded-3xl">{mobile}</span>
            <input
              type="password"
              className=" w-3/4 h-10 box-border mb-1 p-3 outline-none shadow-xl rounded-3xl"
              placeholder="Enter OTP"
              maxLength={6}
              ref={finalotp}
              required
            />
            <div className=" resend-otp mb-5 w-[70%] "><span className="text-gray-600">Didn't Receive OTP?{" "}</span>
            <span className="text-amber-950 cursor-pointer font-bold hover:underline" onClick={resendHandle}>Resend</span>
            </div></>:""}
            {!otp?<div className="get-otp w-3/4 h-10 box-border mb-5 text-center cursor-pointer font-bold pt-1.5 text-white text-xl shadow-xl rounded-xl bg-gradient-to-l from-amber-950 via-amber-900 to-amber-800" onClick={getOtp}>
              Get OTP
            </div>:
            <div className=" login-submit w-3/4 h-10 box-border mb-5 text-center cursor-pointer font-bold pt-1.5 text-white text-xl shadow-lg rounded-xl bg-gradient-to-l from-amber-950 via-amber-900 to-amber-800 hover:shadow-none" onClick={loginHandle}>
              Submit
            </div>}
            {!otp?<div className="register-text mb-5 cursor-default">
              <span className="text-gray-600">Dont have an account?{" "}</span>
              <span className="text-amber-950 font-bold cursor-pointer hover:underline" onClick={registerToggle}>
                Register
              </span>
            </div>:""}
          </div>
        </div>
      </div>:""}
      {isloader?<div className='fixed inset-0 z-50 bg-gray-200 bg-opacity-50 flex justify-center items-center'>
              <Oval
              visible={true}
              height="80"
              width="80"
              color="#995500"
              ariaLabel="oval-loading"
              wrapperStyle={{}}
              wrapperClass=""
              secondaryColor='none'
              strokeWidth={3}
              />
              </div>:""}
      </>
  )
}
